define('Components/InstagramWidget/js/views/InstagramDefaultView',[
        'jquery',
        'app',
        'ProductBlockView',
        'underscore',
        'Components/InstagramWidget/js/views/InstagramWidgetInstanceView',
        'InternalLinkView',
        'template!Components/InstagramWidget/templates/blocks/postDetails',
        'template!Components/InstagramWidget/templates/blocks/postBlock',
    ],
    function ($, app, ProductBlockView, _,
              InstagramWidgetInstanceView,
              InternalLinkView,
              postDetailsTemplate,
              postBlockTemplate

    ) {

        var postsLoaded = [];

        function bottomNoticeProduct(actionLabel){
            app.bottomNotice(t('Le produit a bien été '+actionLabel+' au panier', 'Cart'));
        }

        // BLOCK, ELEMENTS AND MODIFIERS SELECTORS
        var _DOT_ = '.',
            _INSTAGRAM_WIDGET_ = 'instagram-widget',
            _INSTAGRAM_WIDGET__POST_ = _INSTAGRAM_WIDGET_ + '__post',
            _INSTAGRAM_WIDGET__POST__OVERLAY_ = _INSTAGRAM_WIDGET__POST_ + '__overlay',
            _INSTAGRAM_WIDGET__POST__DETAILS_ = _INSTAGRAM_WIDGET__POST_ + '__details',
            _INSTAGRAM_WIDGET__POST__DETAILS_SLIDER_ = _INSTAGRAM_WIDGET__POST__DETAILS_ + '__slider',
            _PRODUCT_BLOCK_ = _INSTAGRAM_WIDGET__POST__DETAILS_SLIDER_ + ' .product-block',
            _UNFOLDED_ = 'unfolded ',
            _FOLDED_ = 'folded ',
            _FOLDING_ANIMATION_DURATION_ = 1500;

        // SCREEN WIDTH BREAKPOINTS
        var _SCREEN_LARGE_ = 1600,
            _SCREEN_MEDIUM_ = 1460,
            _SCREEN_SMALL_ = 991;

        return InstagramWidgetInstanceView.extend({
            name: 'InstagramDefaultView',
            events: {
                'click .instagram-widget-page .instagram-widget__post': 'showDetails'
            },
            privateSetup:function(){
                var view = this,
                    cartProducts = app.getCart().getProducts();
                view.listenTo(cartProducts, 'add', view.onAddProduct);
                view.listenTo(cartProducts, 'remove', view.onAddProduct);
            },
            onAddProduct: function () {
                bottomNoticeProduct('ajouté');
            },
            onRemoveProduct: function () {
                bottomNoticeProduct('retiré');
            },

            afterRender: function () {
                var view = this;
                view.$('.inline-loader').hide();
                view.$('.instagram-widget').css('display', 'flex');

                // Push ID of already loaded posts in a array
                view.$el.find(_DOT_ + _INSTAGRAM_WIDGET__POST_).each(function () {
                    postsLoaded.push(parseInt($(this).data('post')));
                });
                view.$('img').one('load', function () {
                    view.$el.addClass('loaded');
                });

                view.listenTo(app, 'scroll', view.lazyLoad);
                view.listenTo(app, 'scroll', view.infiniteScroll);

                setTimeout(function () {
                    view.lazyLoad()
                }, 100);

                InternalLinkView.initializeLinksOfView(view);
            },

            showDetails: function (el) {
                var view = this;
                var $post = $(el.currentTarget);

                view.activateOverlay($post);
                view.appendTemplate($post);
                view.scrollToPostDetailsBlock();

            },
            /**
             * Scroll to _INSTAGRAM_WIDGET__POST__DETAILS_
             * @returns {undefined}
             */
            scrollToPostDetailsBlock: function () {
                var $postDetails = $(_DOT_ + _INSTAGRAM_WIDGET__POST__DETAILS_ + _DOT_ + _UNFOLDED_);
                setTimeout(function () {
                    if($postDetails.get(0))
                        app.scrollTop(($postDetails.offset().top) - ($(window).height() - ($postDetails.outerHeight(true))) / 2, 500);
                }, 500)

            },
            /**
             * Get responsive columns count
             * @returns {number}
             */
            getColumnCount: function () {
                var screenWidth = $(window).width(), count;
                if (screenWidth > _SCREEN_LARGE_) {
                    count = 6;
                } else if (screenWidth > _SCREEN_MEDIUM_){
                    count = 5;
                } else if (screenWidth > _SCREEN_SMALL_) {
                    count = 4;
                } else {
                    count = 2;
                }
                return count;
            },
            /**
             * Append a template to a given index
             * @param {jQuery} $el
             * @param {number} columnCount
             * @returns {undefined}
             */
            appendTemplate: function ($el) {
                var view = this,
                    columnCount = view.getColumnCount(),
                    post = app.getInstagramPost($el.data('post')),
                    products = [],
                    indexToAdd = view.computeIndexToAppendTemplate($el.data('index'), columnCount);

                _.each(post.get('products'), function (productId) {
                    products.push(app.getProduct(productId));
                });

                var className =  app.isDesktop() ? '' : 'mobile-inline s-size';

                var $template = $(postDetailsTemplate({
                    post: post,
                    className: className,
                    products: products
                }));
                console.log('add',indexToAdd);
                view.$(_DOT_ + _INSTAGRAM_WIDGET__POST_ + '[data-index="' + indexToAdd + '"]').after($template);
                $template.removeClass('folded')
                    .addClass('unfolded');

                if (app.isDesktop()) {
                    view.fitPostDetailsWidth($template);
                }

                view.$(_DOT_ + _INSTAGRAM_WIDGET__POST__DETAILS_)
                    .not($template)
                    .removeClass('unfolded')
                    .addClass('folded');

                view.$('.not-buyable.inactive').remove();

                view.$('.product-block').on('mouseover', function () {
                    $(this).addClass('hover');
                }).on('mouseleave', function () {
                    $(this).removeClass('hover');
                });

                view.lazyLoad();

                view.$('.icon-cross').on('click', function () {
                    view.$(_DOT_ + _INSTAGRAM_WIDGET__POST__DETAILS_ + _DOT_ + _UNFOLDED_)
                        .removeClass('unfolded')
                        .addClass('folded');
                    view.removeTemplate(view.$(_DOT_ + _INSTAGRAM_WIDGET__POST__DETAILS_ + _DOT_ + _UNFOLDED_));
                    console.log(_DOT_ + _INSTAGRAM_WIDGET__POST__DETAILS_ + _UNFOLDED_);
                });

                $(_DOT_ + _PRODUCT_BLOCK_ + ' .picture').addClass('picture--no-placeholder');

                var winWidth = app.$window.width(), perPage = 0;
                if (winWidth > _SCREEN_LARGE_) {
                    perPage = 4;
                } else if (winWidth > _SCREEN_MEDIUM_){
                    perPage = 3;
                } else if (app.isDesktop()) {
                    perPage = 2
                }
                if(perPage>0) view.addSlider(_DOT_ + _UNFOLDED_ + _DOT_ + _INSTAGRAM_WIDGET__POST__DETAILS_SLIDER_, perPage);

                view.attachViews(ProductBlockView.initializeProductBlocksOfView(view));

                view.removeTemplate($el);
            },
            removeTemplate: function ($el) {
                var view = this;

                view.desactivateOverlay($el);

                if (app.isDesktop()) {
                    $(_DOT_ + _INSTAGRAM_WIDGET__POST__DETAILS_ + _DOT_ + _FOLDED_).css('margin', '0 10px');
                }

                setTimeout(function () {
                    $(_DOT_ + _INSTAGRAM_WIDGET__POST__DETAILS_ + _DOT_ + _FOLDED_)
                        .remove();
                }, _FOLDING_ANIMATION_DURATION_);
            },
            /**
             * Adapt _INSTAGRAM_WIDGET__POST__DETAILS_ width to fit with
             * _INSTAGRAM_WIDGET__POST_ gutter
             * @param {jQuery} $template
             * @returns {undefined}
             */
            fitPostDetailsWidth: function ($template) {
                $template.find(_DOT_ + _INSTAGRAM_WIDGET__POST__DETAILS_SLIDER_).css('marginLeft', '20px');
            },
            activateOverlay: function ($el) {
                $el.find(_DOT_ + _INSTAGRAM_WIDGET__POST__OVERLAY_)
                    .removeClass('visible')
                    .addClass('active');
            },
            desactivateOverlay: function ($el) {
                $(_DOT_ + _INSTAGRAM_WIDGET__POST__OVERLAY_)
                    .not($el.find(_DOT_ + _INSTAGRAM_WIDGET__POST__OVERLAY_))
                    .removeClass('active')
            },
            /**
             * Check if _INSTAGRAM_WIDGET_ div has reached the end of window
             * and load posts that are not already present in DOM
             * @returns {undefined}
             */
            infiniteScroll: function () {
                var view = this;
                var $list = view.$(_DOT_ + _INSTAGRAM_WIDGET_),
                    listOffset = $list.offset();
                if (listOffset && ($(window).scrollTop() >= listOffset.top + $list.outerHeight() - window.innerHeight)) {
                    var i = 0;
                    view.model.getPosts().each(function (post) {
                        if (i < view.model.getPostsPerLoad()
                            && postsLoaded.indexOf(parseInt(post.get('id_insta_post'))) === -1) {
                            view.appendPostTemplate(post);
                            postsLoaded.push(parseInt(post.get('id_insta_post')));
                            i++;

                            // If all posts are loaded, unbind view.infintieScroll() to onScroll event
                            if (postsLoaded.length >= view.model.getPosts().length) {
                                view.stopListening(app, 'scroll', view.infiniteScroll);
                            }
                        }
                    })
                }
            },
            /**
             * Load and append post template on the fly (used with view.infiniteScroll())
             * @param {Backbone} post
             * @returns {undefined}
             */
            appendPostTemplate: function (post) {
                var view = this;
                var lastPostIndex = view.$el.find(_DOT_ + _INSTAGRAM_WIDGET__POST_).last().index();
                var products = [];
                _.each(post.get('products'), function (productId) {
                    products.push(app.getProduct(productId));
                });
                var $template = templates.ComponentsInstagramWidgetTemplatesBlocksPostBlock
                ({
                    post: post,
                    index: lastPostIndex + 1,
                    products: products
                });

                $(_DOT_ + _INSTAGRAM_WIDGET__POST_ + '[data-index="' + lastPostIndex + '"]').after($template);

            },
            /**
             * Create new Siema slider
             * @param {string} selector         The selector to use as a carousel
             * @param {number|Object} perPage   The number of slides to be shown
             * @param {number} threshold        Touch and mouse dragging threshold (in px)
             * @param {number} duration         Slide transition duration in milliseconds
             * @param {boolean} loop            Loop the slides around
             * @returns {undefined}
             */
            addSlider: function (selector, perPage, threshold, duration, loop) {
                var view = this, siemaSlider;
                InstagramWidgetInstanceView.prototype.addSlider.apply(this,arguments);
                siemaSlider = view.siemaSlider;

                if (app.isDesktop() && siemaSlider) {
                    var elementsCount = siemaSlider.innerElements.length,
                        winWidth = app.$window.width();
                    if (elementsCount > 3 && winWidth > _SCREEN_MEDIUM_) {
                        view.bindMouseWheelEventSlider(selector);
                    } else if (elementsCount > 4 && winWidth > _SCREEN_LARGE_) {
                        view.bindMouseWheelEventSlider(selector);
                    }
                }
            },


            /**
             * Compute index to append template for responsive purposes
             * @param {number} sourceIndex
             * @param {number} columnCount
             * @returns {number}
             */
            computeIndexToAppendTemplate: function (sourceIndex, columnCount) {
                var view = this,
                    index = Math.floor(sourceIndex / columnCount + 1) * columnCount - 1,
                    postsCount = view.$(_DOT_ + _INSTAGRAM_WIDGET__POST_).length,
                    postsLastLineIndex = Math.floor(postsCount / columnCount) * columnCount;

                // si on est au dessus de la dernière ligne, on passe à une ligne en dessus
                if (index > postsLastLineIndex && postsLastLineIndex > 0) {
                    index = postsLastLineIndex - 1;
                }
                return index;
            },

            /**
             * Bind mouse wheel event to Siema slider to navigate between slides
             * @param {string} el
             * @returns {undefined}
             */
            bindMouseWheelEventSlider: function (el) {
                var view = this;
                $(el).bind('DOMMouseScroll', function (e) {
                    if (e.originalEvent.detail < 0) {
                        view.siemaSlider.prev();
                    } else {
                        view.siemaSlider.next();
                    }
                    return false;
                });

                $(el).bind('mousewheel', function (e) {
                    if (e.originalEvent.wheelDelta > 0) {
                        view.siemaSlider.prev();
                    } else {
                        view.siemaSlider.next();
                    }
                    return false;
                });
            },

            })
    });
